import(/* webpackMode: "eager" */ "/home/ubuntu/deployment_scripts/frontend/src/app/(common)/blogs/[slug]/page.js");
